// extracted by mini-css-extract-plugin
export default {"root":"FcRAZ2h3tC","itemsContainer":"AkLZeEZKU_"};